import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function SNDiagnosticCodeSelect(props) {
	const { schema, formData, onChange } = props;
	const { title } = schema;
	const [data, setData] = useState(formData || []);

	const fields = [
		{
			name: "first",
			label: "Select Primary"
		},
		{
			name: "second",
			label: "Select next relevant"
		},
		{
			name: "third",
			label: "Select next relevant"
		}
	]
	let {
		F227: diagnosisCodes
	} = useSelector(state => state.form.formData);

	useEffect(() => {
		if (_.isEmpty(data)) {
			setData({
				first: "",
				second: "",
				third: ""
			})
		}
	}, [formData]);

	useEffect(() => {
		onChange(data);
	}, [data])

	function renderOptions(value) {
		return diagnosisCodes ? diagnosisCodes.map((item, i) => (
			<option value={item} key={i}>{item}</option>
		)) : null;
	}

	function handleChange(e) {
		setData({
			...data,
			[e.target.name]: e.target.value
		})
	}

	return (
		<React.Fragment>
			<label>{title}</label>

			{
				fields.map((field, i) => (
					<div className="form-group" key={i}>
						<select
							className="form-control"
							name={field.name}
							value={data[field.name]}
							defaultValue={data[field.name]}
							onChange={handleChange}
						>
							<option defaultValue="">{field.label}</option>
							{renderOptions(data[field.name])}
						</select>
					</div>
				))
			}
		</React.Fragment >
	)
}

export default SNDiagnosticCodeSelect;